export const PRODUCT = "product"
export const BENEFIT = "benefit"
export const FLOTILLA = "flotilla"
export const PLAN = "plan"
